// extracted by mini-css-extract-plugin
export default {"socials":"socials_socials__VJ2UR"};